import { Service } from "./service";

export class UserService extends Service {
  static async signIn(credentials: API.LoginReq) {
    try {
      const response = await UserService.post<API.LoginReq, API.LoginData>("/users/login", credentials);
      if (response?.data?.data?.accessToken && response.data.data.user) {
        return response?.data?.data;
      } else {
        throw new Error("Wrong login response");
      }
    } catch (err) {
      UserService.errorHandler(err);
    }
  }
  static async register(signupData: API.RegisterReq): Promise<API.RegisterData> {
    try {
      const response = await UserService.post<API.RegisterReq, API.RegisterData>("/users/register", signupData);
      if (response?.data?.data?.success) {
        return response?.data.data;
      } else {
        throw new Error("Error getting userdata");
      }
    } catch (err) {
      throw UserService.errorHandler(err);
    }
  }
  static async resendActivation(resendActivationData: API.ResendActivationReq): Promise<API.ResendActivationData> {
    try {
      const response = await UserService.post<API.ResendActivationReq, API.ResendActivationData>("/users/resend-activation", resendActivationData);
      if (response?.data?.data?.success) {
        return response?.data.data;
      } else {
        throw new Error("Error getting userdata");
      }
    } catch (err) {
      throw UserService.errorHandler(err);
    }
  }
  static async getUserdata(accessToken: string): Promise<API.UserData> {
    try {
      const response = await UserService.get<API.GetUserdataData>("/users/get-userdata", accessToken);
      if (response?.data?.data?.user) {
        return response?.data?.data.user as API.UserData;
      } else {
        throw new Error("Error getting userdata");
      }
    } catch (err) {
      throw UserService.errorHandler(err);
    }
  }
  static async setPhone(accessToken: string, phoneData: API.PhoneSetupReq): Promise<API.UserProfile> {
    try {
      const response = await UserService.post<API.PhoneSetupReq, API.PhoneSetupData>(
        "/users/phone-setup",
        phoneData,
        accessToken
      );
      if (response?.data?.data?.success && response?.data?.data?.profile) {
        return response?.data?.data.profile as API.UserProfile;
      } else {
        throw new Error("Error getting userdata");
      }
    } catch (err) {
      throw UserService.errorHandler(err);
    }
  }
  static async editPhone(accessToken: string): Promise<API.UserProfile> {
    try {
      const response = await UserService.get<API.PhoneEditData>("/users/phone-edit", accessToken);
      if (response?.data?.data?.success && response?.data?.data?.profile) {
        return response?.data?.data.profile as API.UserProfile;
      } else {
        throw new Error("Error getting userdata");
      }
    } catch (err) {
      throw UserService.errorHandler(err);
    }
  }
  static async resendSMS(accessToken: string): Promise<API.TrueFalseData> {
    try {
      const response = await UserService.get<API.ResendSMSData>("/users/resend-sms", accessToken);
      if (response?.data?.data) {
        return response?.data?.data;
      } else {
        throw new Error("resendSMS wrong response");
      }
    } catch (err) {
      throw UserService.errorHandler(err);
    }
  }
  static async phoneCode(accessToken: string, codeData: API.PhoneCodeReq): Promise<API.UserProfile> {
    try {
      const response = await UserService.post<API.PhoneCodeReq, API.PhoneCodeData>("/users/phone-code", codeData, accessToken);
      if (response?.data?.data?.success && response?.data?.data?.profile) {
        return response?.data?.data.profile as API.UserProfile;
      } else {
        throw new Error("Error sending sms code");
      }
    } catch (err) {
      throw UserService.errorHandler(err);
    }
  }
  static async agreement(accessToken: string, agreement: API.AgreementReq): Promise<API.AgreementData> {
    try {
      const response = await UserService.post<API.AgreementReq, API.AgreementData>("/users/agreement", agreement, accessToken);
      if (response?.data?.data?.success && response?.data?.data?.profile) {
        return response?.data?.data;
      } else {
        throw new Error("Error sending agreement");
      }
    } catch (err) {
      throw UserService.errorHandler(err);
    }
  }
  static async updateProfile(accessToken: string, updateProfileReq: API.UpdateProfileReq): Promise<API.UserProfile> {
    try {
      const response = await UserService.post<API.UpdateProfileReq, API.UpdateProfileData>("/users/update-profile", updateProfileReq, accessToken);
      if (response?.data?.data?.success && response?.data?.data?.profile) {
        return response?.data?.data.profile;
      } else {
        throw new Error("Error updating profile");
      }
    } catch (err) {
      throw UserService.errorHandler(err);
    }
  }
  static async updateCard(accessToken: string, updateCardReq: API.UpdateCardReq): Promise<API.UserBillingInfo> {
    try {
      const response = await UserService.post<API.UpdateCardReq, API.UpdateCardData>("/subscriptions/update-card", updateCardReq, accessToken);
      if (response?.data?.data?.success && response?.data?.data?.billingInfo) {
        return response?.data?.data.billingInfo;
      } else {
        throw new Error("Error updating card");
      }
    } catch (err) {
      throw UserService.errorHandler(err);
    }
  }
  static async cancelSubscription(accessToken: string): Promise<API.UserSubscription> {
    try {
      const response = await UserService.get<API.CancelSubscriptionData>("/subscriptions/cancel", accessToken);
      if (response?.data?.data?.success && response?.data?.data?.subscription) {
        return response?.data?.data.subscription;
      } else {
        throw new Error("Error cancel subscription");
      }
    } catch (err) {
      throw UserService.errorHandler(err);
    }
  }
  static async reactivateSubscription(accessToken: string): Promise<API.UserSubscription> {
    try {
      const response = await UserService.get<API.ReactivateSubscriptionData>("/subscriptions/reactivate", accessToken);
      if (response?.data?.data?.success && response?.data?.data?.subscription) {
        return response?.data?.data.subscription;
      } else {
        throw new Error("Error reactivate subscription");
      }
    } catch (err) {
      throw UserService.errorHandler(err);
    }
  }
  static async activateSubscription(accessToken: string, activateSubscriptionReq: API.ActivateSubscriptionReq): Promise<API.UserSubscription> {
    try {
      const response = await UserService.post<API.ActivateSubscriptionReq, API.ActivateSubscriptionData>("/subscriptions/activate", activateSubscriptionReq, accessToken);
      if (response?.data?.data?.success && response?.data?.data?.subscription) {
        return response?.data?.data.subscription;
      } else {
        throw new Error("Error activate subscription");
      }
    } catch (err) {
      throw UserService.errorHandler(err);
    }
  }
  static async getDiscount(accessToken: string, getDiscountReq: API.GetDiscountReq): Promise<API.DiscountData> {
    try {
      const response = await UserService.post<API.GetDiscountReq, API.GetDiscountData>("/subscriptions/get-discount", getDiscountReq, accessToken);
      const data = response?.data?.data;
      if (data && data?.success && data?.discount) {
        return data.discount;
      } else {
        throw new Error("Coupon applying error");
      }
    } catch (err) {
      throw UserService.errorHandler(err);
    }
  }
}